import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, type RadioGroupProps } from '@mui/material';

export type HFRadioOption = { value: string; label: string; disabled?: boolean };

export type HFRadioGroupProps = Omit<RadioGroupProps, 'onChange'> & {
  label?: string;
  options: HFRadioOption[];
  onChange?: (value: string) => void;
};

export function HFRadioGroup({ label, options, onChange, row = true, ...props }: HFRadioGroupProps) {
  return (
    <FormControl>
      {label != null ? <FormLabel>{label}</FormLabel> : null}
      <RadioGroup row={row} {...props} onChange={(_, value) => onChange?.(value)}>
        {options.map((option) => (
          <FormControlLabel key={option.value} value={option.value} control={<Radio />} label={option.label} disabled={option.disabled} />
        ))}
      </RadioGroup>
    </FormControl>
  );
}
